import { observer } from 'mobx-react-lite'
import { Alert, Button, Divider, Label, TextareaWithLabel, UploadDoc } from 'shared/ui'
import { LINK_RCS_GUIDE } from 'shared/constants/links'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { UploadedFileCard } from 'pages/settings/pages/rcsV2/ui/UploadedFileCard/UploadedFileCard'

import styles from './styles.module.scss'

export const UseCase = observer(() => {
  const {
    navigationStore,
    useCaseStore: {
      description,
      video,
      videoError,
      descriptionMinLength,
      descriptionMaxLength,
      isNextDisabled,
      setDescription,
      setVideo,
      removeVideo,
      clearVideoError,
    },
  } = useRcsWizardContext()

  const onNext = () => {
    navigationStore.goToNextStep(RcsWizardSteps.useCase)
  }

  return (
    <div className={styles.wrap}>
      <PageDescription>
        Select the campaign use case that best describes the type of messaging you plan to send. Add
        a description of your specific texting use case.
        <LearnMoreLink href={LINK_RCS_GUIDE}>Learn more</LearnMoreLink>
      </PageDescription>

      <TextareaWithLabel
        className={styles.descriptionField}
        classNameTextarea={styles.fieldText}
        value={description}
        onChange={setDescription}
        limit={descriptionMaxLength}
        minLimit={descriptionMinLength}
        errorType='bottomText'
        name='description'
        placeholder='Add a description of how the selected use case applies to your business'
        labelProps={{
          marginBottom: 0,
          label: {
            text: 'Use case description',
            rightNode: <Button text='See example' size='small' typeBtn='informative' />,
          },
        }}
      />

      <Divider
        sx={{ marginTop: '35px', marginBottom: '28px', borderColor: 'var(--black-10)' }}
        orientation='horizontal'
      />

      <Label
        marginBottom={4}
        questionTooltipProps={{
          type: 'description',
          label: 'Use case video',
        }}
        label={{
          text: 'Use case video',
          rightNode: <Button text='See example' size='small' typeBtn='informative' />,
        }}
      />

      {videoError && (
        <Alert
          item={{ title: videoError.title, desc: videoError.desc, type: 'error' }}
          onClose={clearVideoError}
          marginBottom={12}
        />
      )}

      <UploadDoc
        uploadTypeText='Acceptable file types: mp4, mov up to 100 MB'
        onChange={setVideo}
      />

      {video && <UploadedFileCard file={video} type='video' onRemove={removeVideo} />}

      <NextButton text='Next' disabled={isNextDisabled} onClick={onNext} />
    </div>
  )
})
